import React, { Component } from "react";
import styled from "styled-components";
import SunIcon from "../../../assets/images/ems/sun-icon.png";
import DatabasePowerIcon from "../../../assets/images/ems/database-power.png";
import ChartPieIcon from "../../../assets/images/ems/chart-pie.png";
import BoltBoltIcon from "../../../assets/images/ems/bolt-bolt.png";
import EnergySocketIcon from "../../../assets/images/ems/energy-socket.png";
import EnergyIcon from "../../../assets/images/ems/energy.png";
import LightningBoltIcon from "../../../assets/images/ems/lightning-bolt.png";
import CountUp from "react-countup";
import TitleWithContent from "../common/TitleWithContent";
import { BoxWrapper } from "../common/style";
import CS from "../../../commons/services/Common";
import { withTranslation } from "react-i18next";
import AutoFitText from "../../../commons/components/text/AutoFitText";

class PowerPlantInfo extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      inv: {
        power: 0,
        operationRate: 0,
        dayPower: 0,
      },
      carrier: {
        totalCons: 0,
        pwCons: 0,
        dayPwCons: 0,
      },
      battery: {
        operationRate: 0,
        dayCharge: 0,
        dayDischarge: 0,
        dayChargeTime: '0h 0m',
        dayDischargeTime: '0h 0m',
        totalCharge: 0,
        totalChargeTime: '0h 0m',
        totalDischarge: 0,
        totalDischargeTime: '0h 0m',
        batteryCapacity: this.props?.batteryCapacity || 0,
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this.setInvData();
      this.setCarrierData();
      this.setBatteryData();
    }
  }

  setInvData() {
    const { plantList, emsInvSum, emsInvData } = this.props;
    let power = 0;
    let dayAccumulation_power = 0;
    let totalCapacity = 0;

    emsInvSum.forEach((inv) => {
      power += inv.power || 0;
      dayAccumulation_power += inv.day_accumulation_power || 0;
    })
  
    plantList.forEach((plant) => {
      totalCapacity += plant.installationCapacity || 0;
    })

    const newInv = {
      power,
      operationRate: power / totalCapacity * 100,
      dayPower: dayAccumulation_power,
    }
    this.setState({ inv: newInv });
  }

  setCarrierData() {
    const { emsCarrierSum = [], deviceData } = this.props;
    if (emsCarrierSum.length === 0) return;

    const totalCons = CS.sumValuesAtPath(deviceData, 'totalConsPower');
    const pwCons = emsCarrierSum[0]?.power || 0;
    const dayPwCons = emsCarrierSum[0]?.day_total_cons_power || 0;

    const newCarrier = {
      totalCons,
      pwCons,
      dayPwCons,
    }

    this.setState({ carrier: newCarrier });
  }

  setBatteryData() {
    const { emsBatterySum, emsBatteryData, batteryCapacity, battery } = this.props;
    if (emsBatterySum.length === 0) return;
    const totalCharge = CS.sumValuesAtPath(emsBatterySum, 'total_ed1_charge_wattage');
    const totalDischarge = CS.sumValuesAtPath(emsBatterySum, 'total_ed2_discharge_wattage');
    const dayCharge = CS.sumValuesAtPath(emsBatterySum, 'day_ed1_charge_wattage');
    const dayDischarge = CS.sumValuesAtPath(emsBatterySum, 'day_ed2_discharge_wattage');
    const dayChargeTime = this.calcTimeAndFormat(dayCharge, batteryCapacity);
    const dayDischargeTime = this.calcTimeAndFormat(dayDischarge, batteryCapacity);
    const operationRate = (Math.abs(dayCharge / batteryCapacity) + Math.abs(dayDischarge / batteryCapacity)) / 24 * 100;
    
    const newBattery = {
      operationRate: operationRate,
      dayCharge,
      dayDischarge,
      dayChargeTime,
      dayDischargeTime,
      totalCharge,
      totalChargeTime: this.calcTimeAndFormat(totalCharge, batteryCapacity), // 누적 충전시간 계산 필요
      totalDischarge,
      totalDischargeTime: this.calcTimeAndFormat(totalDischarge, batteryCapacity), // 누적 방전시간 계산 필요
      batteryCapacity: batteryCapacity || 0,
    }
    
    this.setState({ battery: {...newBattery} });
  }

  // chargeTime, dischargeTime 계산 함수 
  // return 값 (hh)h (mm)m
  calcTimeAndFormat(kWh, capacityKw) {
    if (capacityKw === 0) return "0h 0m";
    if (kWh === 0) return "0h 0m";

    const time = kWh / capacityKw;
    const hour = Math.floor(time);
    const minute = Math.floor((time - hour) * 60);
    return `${hour}h ${minute}m`;
  }

  render() {
    const { t, i18n } = this.props;
    const {
      inv,
      carrier,
      battery
    } = this.state;
    const {
      power,
      operationRate: InvOperationRate,
      dayPower,
    } = inv;

    const {
      totalCons,
      pwCons,
      dayPwCons,
    } = carrier;

    const {
      operationRate: batteryOperationRate,
      dayCharge,
      dayDischarge,
      dayChargeTime,
      dayDischargeTime,
      totalCharge,
      totalChargeTime,
      totalDischarge,
      totalDischargeTime,
      batteryCapacity,
    } = battery;

    return (
      <>
        <TitleWithContent title={t('key104')}>
          <BoxWrapper height={"117px"}>
            <PowerPlantInfoRow title={t('key105')} value={power} unit={"kW"} t={t}/>
            <PowerPlantInfoRow title={t('key106')} value={InvOperationRate} unit={"%"} t={t}/>
            <PowerPlantInfoRow title={t('key107')} value={dayPower} unit={"kW"} t={t}/>
          </BoxWrapper>
        </TitleWithContent> 
        <TitleWithContent title={t('key108')}>
          <BoxWrapper height={"117px"}>
            <PowerPlantInfoRow title={t('key109')} value={pwCons} unit={"kW"} t={t}/>
            <PowerPlantInfoRow title={t('key110')} value={dayPwCons} unit={"kW"} t={t}/>
            <PowerPlantInfoRow title={t('key111')} value={totalCons} unit={"kW"} t={t}/>
          </BoxWrapper>
        </TitleWithContent>         
        <TitleWithContent title={t('key112')}>
          <BatteryWrapper>
            <BoxWrapper height={"117px"}>
              {/* <PowerPlantInfoRow title={t('key113')} value={batteryOperationRate} unit={"%"} t={t}/>  */}
              <PowerPlantInfoRow title={t('key114')} value={dayCharge} unit={"kWh"} t={t}/>
              <PowerPlantInfoRow title={t('key115')} value={dayDischarge} unit={"kWh"} t={t}/>
              <PowerPlantInfoRow title={""} value={""} unit={""} t={t}/>
            </BoxWrapper>
            <BoxWrapper height={"117px"}>
              <PowerPlantInfoRow title={t('key116')} value={dayChargeTime} t={t}/>
              <PowerPlantInfoRow title={t('key117')} value={dayDischargeTime} t={t}/>
              <PowerPlantInfoRow title={""} value={""} unit={""} />
            </BoxWrapper>
            <BoxWrapper height={"117px"}>
              <PowerPlantInfoRow title={t('key118')} value={totalCharge} unit={"kWh"} t={t}/>
              <PowerPlantInfoRow title={t('key119')} value={totalChargeTime} t={t}/>
              <PowerPlantInfoRow title={t('key120')} value={totalDischarge} unit={"kWh"} t={t}/>
              <PowerPlantInfoRow title={t('key121')} value={totalDischargeTime} t={t}/>
            </BoxWrapper>
          </BatteryWrapper>
        </TitleWithContent>
      </>
    )
  }
}

const BatteryWrapper = styled.div`
  display: grid;
  grid-template-columns: 210px 210px 276px;
  gap: 15px;
  width: 100%;
`;

class PowerPlantInfoRow extends Component {

  getImgByTitle(title, t) {
    switch(title) {
      case t('key105'): case t('key116'): case t('key119'): case t('key121'):
        return DatabasePowerIcon;
      case t('key113'):
        return ChartPieIcon;
      case t('key115'):
        return SunIcon;
      case t('key109'):
        return EnergySocketIcon;
      case t('key110'): case t('key115'): case t('key117'):
        return LightningBoltIcon;
      case t('key114'):
        return EnergyIcon;
      case t('key118'): case t('key120'): case t('key111'):
        return BoltBoltIcon;
      default:
        return "";
    }
  }

  render() {
    const {
      title,
      value,
      unit = "",
      t
    } = this.props;
    return(
      <PowerPlantInfoRowWapper>
        {
          title && (
            <img src={this.getImgByTitle(title, t)} alt="" className="icon"/>
          )
        }
        <AutoFitText max={14} min={2}>
          {title}
        </AutoFitText>
        <strong>
          {
            typeof value === "string" ? value : (
              <CountUp 
                start={0}
                end={value}
                duration={1}
              />
            )
          }
          {unit}
        </strong>
      </PowerPlantInfoRowWapper>
    )
  }
}

const PowerPlantInfoRowWapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 16px;
  font-size: 14px;
  line-height: 16px;
  font-weight: 400;
  gap: 4px;

  & strong {
    flex-shrink: 0;
    font-size: 16px;
    font-weight: 600;
  }

  & .icon {
    flex-shrink: 0;
    width: 16px;
    height: 16px;
  }
`;

export default withTranslation()(PowerPlantInfo);